import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { GET, newFetch, POST } from "../../../helpers/fetch";
import "./styles.css";

const CarouselItem = ({ text, t }) => {
  const maxLength = 140;
  const showFullText = () => {
    Swal.fire({
      title: "",
      text: text,
      icon: "info",
      confirmButtonText: t("Close"),
      customClass: {
        icon: "swal-custom-icon",
        confirmButton: "swal-custom-button",
      },
    });
  };

  return (
    <div>
      <p>
        {text.length > maxLength ? (
          <>
            {text.slice(0, maxLength)}...{" "}
            <Link onClick={showFullText} className="see-more-btn" to="#!">
              {t("See More")}
            </Link>
          </>
        ) : (
          text
        )}
      </p>
    </div>
  );
};

const Announcement = ({ t }) => {
  const siteID = localStorage.getItem("default_site_id");
  const user = JSON.parse(localStorage.getItem("user"));
  const texts = [t("No Announcement")];

  const [announcement, setAnnouncement] = React.useState([]);
  const [associate, setAssociate] = React.useState();
  const [allAnnouncements, setAllAnnouncements] = React.useState([]);

  const fetchAnnouncement = async () => {
    const api_path = `/dashboard/announcements`;
    try {
      const response = await newFetch(POST, api_path, { site_id: siteID });

      if (response.success) {
        if (response.data.length > 0) {
          setAllAnnouncements(response.data);
        } else {
          setAnnouncement(texts);
        }
      } else {
        console.error("Failed to fetch announcement:", response.message);
      }
    } catch (error) {
      console.error("Error fetching announcement:", error);
    }
  };

  const fetchAssociate = async (id) => {
    const api_path = `/associate/${id}`;
    try {
      const response = await newFetch(GET, api_path);

      if (response.success) {
        setAssociate(response.data);
      } else {
        console.error("Failed to fetch associate:", response.message);
      }
    } catch (error) {
      console.error("Error fetching associate:", error);
    }
  };

  React.useEffect(() => {
    fetchAnnouncement();
    fetchAssociate(user.id);
  }, [siteID]);

  React.useEffect(() => {
    if (associate && allAnnouncements.length > 0) {
      const lang = associate.language;
      const mapped = allAnnouncements.map((item) =>
        lang === "chi" && item.announcement_cn
          ? item.announcement_cn
          : item.announcement
      );
      setAnnouncement(mapped.length > 0 ? mapped : texts);
    }
  }, [associate, allAnnouncements]);

  return (
    <div
      className="d-flex flex-column dashboard__announcement-container"
      style={{ height: 222 }}
    >
      <Carousel
        showStatus={false}
        showArrows={false}
        infiniteLoop
        autoPlay
        interval={3000}
        showThumbs={false}
        transitionTime={1000}
        swipeable={false}
      >
        {announcement.length > 0
          ? announcement.map((text, index) => (
              <CarouselItem key={index} text={text} t={t} />
            ))
          : texts}
      </Carousel>
    </div>
  );
};

export default Announcement;
